import {
	KForm,
	KTextField,
	KTextarea
} from "kinnect-general";

export default KForm.extend( {
	name: "ThirdPartyServiceForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "thirdPartyServices" } ]
		},

		thirdPartyService: Object
	},

	data: () => ( {
		formFields: {
			description: null,
			name: null,
			price: null,
			url: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.thirdPartyService );
		},

		formUrl() {
			return this.editing
				? `third-party-services/${this.thirdPartyService.id}`
				: "third-party-services";
		}
	},

	watch: {
		thirdPartyService: {
			handler( thirdPartyService ) {
				if ( thirdPartyService ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( thirdPartyService.hasOwnProperty( key ) ) {
							this.formFields[key] = thirdPartyService[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Service Name*"
				prependIcon="extension"
				required
				vModel={this.formFields.name}
				validationName="service name"
				validationRules="required"
			></KTextField>

			<KTextField
				label="Website URL"
				prependIcon="language"
				vModel={this.formFields.url}
				validationName="website URL"
				validationRules={{ url: { require_protocol: true } }}
			></KTextField>

			<KTextField
				hint="i.e. $9.99 / month"
				label="Price / Frequency*"
				prependIcon="attach_money"
				required
				vModel={this.formFields.price}
				validationName="price"
				validationRules="required"
			></KTextField>

			<KTextarea
				label="Description"
				name="description"
				prependIcon="comment"
				vModel={this.formFields.description}
			></KTextarea>
		</KForm>;
	}
} );
